import { NavLink, Navigate, Route, Routes } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { RecruitPage } from './pages/RecruitPage';
import { HeroesPage } from './pages/HeroesPage';
import { WalletPage } from './pages/WalletPage';
import { BattlePage } from './pages/BattlePage';
import { StagesPage } from './pages/StagesPage';
import { DailyTasksPage } from './pages/DailyTasksPage';
import './styles.css';

const navigation = [
  { path: '/', label: '首页', short: '城' },
  { path: '/stages', label: '主线闯关', short: '关' },
  { path: '/heroes', label: '武将', short: '将' },
  { path: '/recruit', label: '招募', short: '召' },
  { path: '/daily-tasks', label: '每日任务', short: '令' },
  { path: '/wallet', label: '钱包', short: '库' },
] as const;

export default function App() {
  return (
    <div className="app-shell">
      <header className="topbar">
        <div>
          <span className="brand-mark"><b>王</b><small>KING</small></span>
          <p><strong>三国 · 守城英雄</strong><small>烽火连城，五将守关</small></p>
        </div>
        <span className="test-badge">测试 KING · 不可提现或交易</span>
        <NavLink className="battle-link" to="/battle">进入战场</NavLink>
      </header>

      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/heroes" element={<HeroesPage />} />
          <Route path="/recruit" element={<RecruitPage />} />
          <Route path="/wallet" element={<WalletPage />} />
          <Route path="/stages" element={<StagesPage />} />
          <Route path="/daily-tasks" element={<DailyTasksPage />} />
          <Route path="/battle" element={<BattlePage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>

      <nav className="bottom-nav" aria-label="主要导航">
        {navigation.map((item) => (
          <NavLink key={item.path} to={item.path} end={item.path === '/'}>
            <span aria-hidden="true">{item.short}</span>
            {item.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
